module.exports = __webpack_public_path__ + "static/media/Ponder-final.bca95ddc.jpg";